
// ./build.py webpack:sentinel_region

async function buildCountyFeatures(regionStates, mapjson_url) {
    const response = await fetch(mapjson_url);
    if (!response.ok) {
      throw new Error(`Failed to load map JSON: ${response.status}`);
    }
    const topology = await response.json();

    const allFeatures = Highcharts.geojson(topology, 'map'); // county polygons as features
    const prefixes = regionStates.map(s => `us-${String(s).toLowerCase()}`);

    return allFeatures.filter(p => {
      const key = p.properties?.['hc-key'] || '';
      return prefixes.some(prefix => key.startsWith(prefix + '-'));
    });
  }

const perYear = year => x => x.year === year;

const countyValueRows = (config, year) =>
  config.county_data.filter(perYear(year))

function formatList(arr) {
  if (arr.length === 0) {
    return '';
  }
  if (arr.length === 1) {
    return `<br/>${arr[0]}`;
  }
  if (arr.length === 2) {
    return `<br/>${arr[0]} and ${arr[1]}`;
  }
  // 3+ items
  const allButLast = arr.slice(0, -1).join(', ');
  const last = arr[arr.length - 1];
  return `<br/>${allButLast}, and ${last}`;
}


function renderMap(config, year, countyPolygons) {
  const mapData = countyValueRows(config, year)
  const container = document.getElementById('map-container');
  if (!container) {
    throw new Error('Missing #map-container element');
  }

  Highcharts.setOptions({
    colors: ['#A1D2F7', '#69164B', '#4E4D86', '#4D79B9', '#AA80FF', '#E7F8FD', '#B300B3', '#B3B3FF', '#00CCFF']
  });

  Highcharts.mapChart(container, {
    title: {
      text: `Sentinel Apiaries ${year}${formatList(config.region_states)}<br/>Average Varroa per 100 Bees`
    },
    colorAxis: {
      min: .025,

      stops: [
        // Green
        [0.05, '#e7f8fd'],
         // Blue
        [0.15, '#9fd2f9'],
        [0.40, '#56b0f5'],
        // purple
        [0.77, '#5a0c41'],
        [0.90, '#430931'],
        [0.95, '#2d0621'],
        [1, '#160310']
      ]
     },
    series: [{
      type: 'map',
      mapData: countyPolygons,
      data: mapData,
      joinBy: ['fips', 'fips'],
      borderColor: '#777',
      borderWidth: 0.6,
      nullColor: '#f2f2f2'
    }]
  });
}

const colonyColors = [
  '#1f77b4', // blue
  '#ff7f0e', // orange
  '#2ca02c', // green
  '#d62728', // red
  '#9467bd', // purple
  '#8c564b', // brown
  '#e377c2', // pink
  '#7f7f7f', // gray
  '#bcbd22', // olive
  '#17becf', // cyan
  '#4e79a7', // steel blue
  '#f28e2b'  // amber
];


function getAvgsByMonthWithDates(avgsByMonth, year) {
  /// format date to match the current selected year
  const result = [];

  for (let month = 4; month <= 10; month++) {
    const value = avgsByMonth[month];
    const monthValue = value ? value.mean : 0;

    // Date.UTC uses zero-based months: Jan = 0, Dec = 11
    const timestamp = Date.UTC(Number(year), month - 1, 15);

    result.push([timestamp, monthValue]);
  }

  return result;
}

function getSeriesFormatted(seriesdata) {

 const formatted = seriesdata.map((series, index) => ({
    ...series,
    type: 'scatter',
    color: colonyColors[index % colonyColors.length],
    zIndex: 2,
    tooltip: {
      pointFormat: `
        <b>{series.name}</b><br/>
        Colony: <b>{point.colony}</b><br/>
        Value: {point.y:.2f}
      `
    }
  }));

  return formatted

};


function renderVarroaScatterChart(varroaData, ushbs_varroa, year) {
  const formatted_ushbs_varroa = getAvgsByMonthWithDates(ushbs_varroa, year)
  const formatted_varroa_data = getSeriesFormatted(varroaData)

   $(`#varroa_scatter_chart`).highcharts({
    chart: {
      type: 'areaspline'
    },
    title: {
        text: 'Average Varroa'
      },
      subtitle: {
        text: `Comparing National Average to Sentinel Apiaries ${year}`
      },
    xAxis: {
      type: 'datetime',
      min: Date.UTC(year, 3, 15),
      max: Date.UTC(year, 9, 15),
      tickPositions: Array.from(
        { length: 12 },
        (_, month) => Date.UTC(year, month, 1)
      ),
      dateTimeLabelFormats: {
        month: '%b'
      },
      labels: {
        step: 1,
        autoRotation: false
      }
    },
    yAxis: {
      title: { text: 'Varroa per 100 Bees' }
    },
    plotOptions: {
      areaspline: {
        color: '#b3c7d6',
        lineColor: '#b3c7d6',
        fillColor: '#b3c7d6',
        fillOpacity: 0.5,

        marker: {
          enabled: false
        }
      }, scatter: {
            dataLabels: {
              enabled: true,
              formatter: function () {
                return Highcharts.numberFormat(this.y, 1)
              }
            }
          }
    },
    tooltip: {
      xDateFormat: '%e %b %Y',
      shared: true
    },
    series: [{
        name: 'USHBS Monthly Average',
        type: 'areaspline',
        data: formatted_ushbs_varroa,

    }, ...formatted_varroa_data]
  });

};


function renderNosemaScatterChart(nosemaData, ushbs_nosema, year) {
  const formatted_ushbs_nosema = getAvgsByMonthWithDates(ushbs_nosema, year)
  const formatted_nosema_data = getSeriesFormatted(nosemaData)

   $(`#nosema_scatter_chart`).highcharts({
    chart: {
      type: 'areaspline'
    },
    title: {
        text: 'Average Vairimorpha'
      },
      subtitle: {
        text: `Comparing National Average to Sentinel Apiaries ${year}`
      },
    xAxis: {
      type: 'datetime',
      min: Date.UTC(year, 3, 15),
      max: Date.UTC(year, 9, 15),
      tickPositions: Array.from(
        { length: 12 },
        (_, month) => Date.UTC(year, month, 1)
      ),
      dateTimeLabelFormats: {
        month: '%b'
      },
      labels: {
        step: 1,
        autoRotation: false
      }
    },
    yAxis: {
      title: { text: 'Million Spores per Bee' }
    },
    plotOptions: {
      areaspline: {
        color: '#b3c7d6',
        lineColor: '#b3c7d6',
        fillColor: '#b3c7d6',
        fillOpacity: 0.5,

        marker: {
          enabled: false
        }
      }, scatter: {
            dataLabels: {
              enabled: true,
              formatter: function () {
                return Highcharts.numberFormat(this.y, 1)
              }
            }
          }
    },
    tooltip: {
      xDateFormat: '%e %b %Y',
      shared: true
    },
    series: [{
        name: 'USHBS Monthly Average',
        type: 'areaspline',
        data: formatted_ushbs_nosema,

    }, ...formatted_nosema_data]
  });

};


document.addEventListener('DOMContentLoaded', async () => {
  let config;
  let countyPolygons;
  try {
    config = JSON.parse(document.getElementById('config').textContent);
    countyPolygons = await buildCountyFeatures(config.region, config.mapjson_url);
    let initialYear = config.initial_year
    renderMap(config, initialYear, countyPolygons);

    const varroaData = config.scatter_series.find(item => item.year === initialYear)?.varroa_per_100_bees;
    renderVarroaScatterChart(varroaData, config.ushbs_varroa, initialYear)

    const nosemaData = config.scatter_series.find(item => item.year === initialYear)?.million_spores_per_bee;
    renderNosemaScatterChart(nosemaData, config.ushbs_nosema, initialYear)

  } catch (error) {
    console.error(error);
  }

  let $yearPicker = $('<select class="form-select form-select-lg"></select>')
  $('.year-picker').append($yearPicker)
  config.all_years.forEach(year => {
    $yearPicker.append(new Option(year, year));
  });
  $yearPicker.val(String(config.initial_year))
  $yearPicker.on('change', () => {
    let year = parseInt($yearPicker.val())
    renderMap(config, year, countyPolygons)

    varroaData = config.scatter_series.find(item => item.year === year)?.varroa_per_100_bees;
    renderVarroaScatterChart(varroaData, config.ushbs_varroa, year)

    nosemaData = config.scatter_series.find(item => item.year === year)?.million_spores_per_bee;
    renderNosemaScatterChart(nosemaData, config.ushbs_nosema, year)

  })

});
